module.exports = __webpack_public_path__ + "img/healthtalk.031e73ce.jpg";